import { j as s } from "./jsx-runtime-3tyXYecC.mjs";
import { useState as d } from "react";
import { r as m } from "./use-readable-context-BO-ExsvT.mjs";
const b = ({ children: e, initialMode: r = "readable" }) => {
  const [t, a] = d(r), o = {
    isReadable: t === "readable",
    setMode: a
  };
  return /* @__PURE__ */ s.jsx(m.Provider, { value: o, children: typeof e == "function" ? e(o) : e });
};
export {
  b as R
};
//# sourceMappingURL=readable-provider-D44066lK.mjs.map
